module.exports = __webpack_public_path__ + "3f49dbc52204ff5ae1379454c95b7e0d.svg";